import React, { useCallback } from 'react';
import { App, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { openPin } from './homePins';

const NEWEST_NOTICE = 'home-newest-record';

/**
 * `open(pin)`: opens or launches a pin exactly as its cell on Home does
 * (homePins.openPin), with the one line a newest-record pin says when
 * nothing matches yet (KPR-1126) — "No Note yet." and, when the person may
 * add one, an **Add one** link to the new-item form where the card lives.
 * Home's strip and the command palette both open pins through this, so the
 * two never answer differently.
 */
export default function useOpenPin() {
	const navigate = useNavigate();
	const { message } = App.useApp();
	return useCallback(pin => openPin(navigate, pin, {
		empty: ({ text, addPath }) => {
			message.open({
				key: NEWEST_NOTICE,
				type: 'info',
				// Long enough to reach the link.
				duration: addPath ? 6 : 3,
				content: (
					<span className="home-newest-notice">
						{text}
						{addPath ? (
							<Button
								type="link"
								size="small"
								className="home-newest-notice__add"
								onClick={() => {
									message.destroy(NEWEST_NOTICE);
									navigate(addPath);
								}}
							>
								Add one
							</Button>
						) : null}
					</span>
				),
			});
		},
		error: text => message.error(text),
	}), [navigate, message]);
}
